import { Toaster } from "react-hot-toast";

import { ScreenSwitchDebugPanel } from "./components/screen-switch-debug-panel";
import { LiveWorkspaceCreationProvider } from "./contexts/LiveWorkspaceCreationContext";
import { GlobalProvider } from "./contexts/globalContext";
import JanusContextProvider from "./contexts/janus/JanusContext";
import MeetingDetailsProvider from "./contexts/meetingDetails/meetingDetailsContext";
import JoinedMeetingScreenIOContextProvider from "./contexts/screenIO/joinedMeetingScreenIOContext";
import UserMediaContextProvider from "./contexts/userMediaContext";
import Routes from "./router";

function App() {
  return (
    <GlobalProvider>
      <UserMediaContextProvider>
        <JanusContextProvider>
          <MeetingDetailsProvider>
            <LiveWorkspaceCreationProvider>
              <JoinedMeetingScreenIOContextProvider>
                <ScreenSwitchDebugPanel />
                <Toaster position="top-right" />
                <Routes />
              </JoinedMeetingScreenIOContextProvider>
            </LiveWorkspaceCreationProvider>
          </MeetingDetailsProvider>
        </JanusContextProvider>
      </UserMediaContextProvider>
    </GlobalProvider>
  );
}

export default App;
